import { RegionsType } from 'src/types/SchoolType';
import { create } from 'zustand';

export interface TeamMember {
  leader: number;         // 1 = 팀장, 0 = 팀원
  uid: number,
  user_name: string;
  user_id: string;
  phone: string;
}

interface TeamData {
  team_id: number;
  team_name: string;
  manager_name: string;
  team_count: number;
  team_member: TeamMember[];
  team_areas: any
}

export interface MemberListState {
  uid: number,
  user_name: string,
  user_id: string,
  phone: string,
  team_name: string
}

interface AdTeamState {
    selectedTeam: TeamData | null
    team_name : string
    manager_uid: number,
    memberList: MemberListState[],
    team_areas: RegionsType,
    tableData:any[]
    setField : (field: keyof AdTeamState, value: any) => void 
    reset: (preserveKeys?: (keyof AdTeamState)[]) => void; // ✅ 변경: 배열로 받기
}

const AdTeamDefault = {
    selectedTeam : null,
    team_name : '',
    manager_uid: 0,
    memberList: [],
    team_areas: {},
    tableData : []
}

export const useAdTeamStore = create<AdTeamState>((set,get)=>({
    ...AdTeamDefault,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: (preserveKeys) => {
    const current = get();
    const preserved: Partial<AdTeamState> = {};

    if (preserveKeys && Array.isArray(preserveKeys)) {
      for (const key of preserveKeys) {
        preserved[key] = current[key] as any;
      }
    }

    set({
      ...AdTeamDefault,
      ...preserved,
    });
  },
}))